
<h2>Touchpoints for {{opCoSelected}}</h2>
<ng-container>
  <p *ngIf="hasMockData">No data available, showing mock data.</p>
  <app-euds-accordion ariaLabel="Filters Section"
                      [allowMultiple]="false"
                      [numbered]="false"
                      [altHeadingColor]="false"
                      class="margin-bottom-5">
    <app-euds-accordion-item label="Filters" icon="feather/filter">
      <div class="touchpoint-filters">
        <app-euds-textfilter label="Account Number"
                             [showResultMessage]="false"
                             [(ngModel)]="filterAccountNumber">
        </app-euds-textfilter>
        <app-euds-textfilter label="Customer Number"
                             [showResultMessage]="false"
                             [(ngModel)]="filterCustomerNumber">
        </app-euds-textfilter>
        <app-euds-textfilter label="Phone Number"
                             [showResultMessage]="false"
                             [(ngModel)]="filterPhoneNumber">
        </app-euds-textfilter>
        <app-euds-select #selectProduct
                         name="product"
                         label="Product"
                         [required]="false"
                         textOptional=""
                         emptyOptionText="All"
                         [(ngModel)]="selectedProduct"
                         (valueChange)="filterProductSelectedOptionChanged($event)">
          <app-euds-option slot="option" *ngFor="let product of productDefinitions" [value]="product.id">{{ product.name }}</app-euds-option>
          <span slot="help">
            Product name or its defined alternative names
            <app-euds-tooltip position="default" icon="info">
              <ul class="euds-list-sm" style="margin-bottom: 0">
                <li *ngFor="let name of productAlternativeNames">
                  {{name}}
                </li>
              </ul>
            </app-euds-tooltip>
          </span>
        </app-euds-select>
        <app-euds-select #selectJourney
                         name="journey"
                         label="Journey"
                         [required]="false"
                         textOptional=""
                         emptyOptionText="All"
                         [disabled]="isJourneyFilterDisabled()"
                         [(ngModel)]="selectedJourney"
                         (valueChange)="filterJourneySelectedOptionChanged($event)">
          <app-euds-option slot="option" *ngFor="let journey of productJourneys" [value]="journey.name">{{ journey.name }}</app-euds-option>
          <span slot="help">
            Journey name or its defined alternative names
            <app-euds-tooltip position="default" icon="info">
              <ul class="euds-list-sm" style="margin-bottom: 0">
                <li *ngFor="let name of journeyAlternativeNames">
                  {{name}}
                </li>
              </ul>
            </app-euds-tooltip>
          </span>
        </app-euds-select>
        <app-euds-filter #eudsFilterStep
                         label="Step"
                         [options]="optionsStepFilter"
                         [disabled]="isStepFilterDisabled()"
                         [hideTextFilter]="true"
                         textNoResultsFound="All"
                         (selectedOptionsChanged)="filterStepSelectedOptionsChanged($event)">
        </app-euds-filter>
        <app-euds-select label="Created Date"
                         [required]="false"
                         textOptional=""
                         emptyOptionText="All"
                         [(ngModel)]="filterCreatedDate"
                         [options]="optionsDateFilter"
                         (valueChange)="filterCreatedDateValueChanged($event)">
        </app-euds-select>
        <app-euds-filter #eudsFilterChannel
                         label="Channel"
                         [options]="optionsChannelFilter"
                         [hideTextFilter]="true"
                         (selectedOptionsChanged)="filterChannelSelectedOptionsChanged($event)">
        </app-euds-filter>
        <app-euds-textfilter label="Result Description"
                             [showResultMessage]="false"
                             [(ngModel)]="filterDescription">
        </app-euds-textfilter>
        <app-euds-date-picker *ngIf="showDateRangeFilter"
                              label="Created Date Range"
                              textOptional=""
                              [required]="false"
                              dateFormat="mm/dd/yyyy"
                              [dateRange]="true"
                              dateRangeDatesDelimiter=" - "
                              [(ngModel)]="createdDateRange"
                              (dateChanged)="createdDateRangeChanged($event)">
        </app-euds-date-picker>
      </div>
      <div class="button-bar">
        <app-euds-button type="primary"
                         label="Apply Filters"
                         (clickEvent)="applyFilters()"></app-euds-button>
        <app-euds-button type="secondary"
                         label="Clear Filters"
                         (clickEvent)="clearFilters()"></app-euds-button>
      </div>
    </app-euds-accordion-item>
  </app-euds-accordion>
  <div class="button-bar-table">
  <app-euds-button type="secondary"
           label="Refresh"
           class="refresh-button"
           icon="feather/refresh-cw"
           iconPosition="left"
           [disabled]="isLoading"
           (clickEvent)="applyFilters(true)">
    </app-euds-button>
    <app-euds-button *ngIf="!isProduction"
                     type="primary"
                     label="Add Touchpoint"
                     [ariaControls]="'touchpoint-drawer'"
                     [ariaExpanded]="isAddTouchpointPanelOpen"
                     icon="feather/plus"
                     iconPosition="left"
                     (clickEvent)="openPanelToAddTouchpoint()"></app-euds-button>
    <app-euds-button *ngIf="!isProduction"
                     type="secondary"
                     label="Run Test Suite"
                     icon="feather/check-circle"
                     iconPosition="left"
                     (clickEvent)="navigateToTesting()"></app-euds-button>
  </div>
  <app-euds-textfilter class="margin-top-2"
                       label="Search"
                       [hideLabel]="true"
                      placeholder="Search Touchpoints..."
                      [resultCount]="filterCount"
                      [showResultMessage]="true"
                      (valueChange)="filterDataSource($event)"
                      (blurEvent)="filterDataSource($event)"
                      (clearEvent)="resetDataSource($event)"
                      (enterEvent)="filterDataSource($event)">
    <span slot="result-message">{{resultMessageText}}</span>
  </app-euds-textfilter>
  <app-euds-data-table #tableTouchpoints class="margin-top-4"
                       *ngIf="displayedTouchpointsData?.length > 0"
                       [showCaption]="false"
                       caption="Touchpoints Table"
                       [condensed]="false"
                       [striped]="true"
                       [dataSource]="displayedTouchpointsData"
                       [columnDefs]="columnDefsTouchpoints"
                       (sortFunction)="sortTableData($event)">
    <ng-container *ngFor="let touchpoint of displayedTouchpointsData, index as idx">
      <tr app-euds-table-row [index]="idx" [class.selected]="touchpoint.id === selectedTouchpoint?.id">
        <td app-euds-table-cell [innerHtml]="touchpoint.accountNumber | highlight: searchText"></td>
        <td app-euds-table-cell [innerHtml]="touchpoint.customerInfo.customerNumber | highlight: searchText"></td>
        <td app-euds-table-cell [innerHtml]="touchpoint.customerInfo.phoneNumber | highlight: searchText"></td>
        <td app-euds-table-cell>{{touchpoint.timestamp | tzAbbr:currentTimeZone}}</td>
        <td app-euds-table-cell [innerHtml]="touchpoint.processingContext?.product | highlight: searchText"></td>
        <td app-euds-table-cell [innerHtml]="touchpoint.processingContext?.journey | highlight: searchText"></td>
        <td app-euds-table-cell [innerHtml]="touchpoint.processingContext?.step | highlight: searchText"></td>
        <td app-euds-table-cell class="touchpoint-description-cell">
          <span class="info-with-icon">
            <app-euds-svg [icon]="getChannelIcon(touchpoint.channel)" size="sm"></app-euds-svg>
            <span [innerHtml]="touchpoint.channel | highlight: searchText"></span>
          </span><br />
          <span class="touchpoint-description-text" [innerHtml]="touchpoint.processingContext?.resultDescription | highlight: searchText"></span>
        </td>
        <td app-euds-table-cell>
          <app-euds-button type="tertiary"
                           size="small"
                           label="Details"
                           [ariaControls]="'touchpoint-drawer'"
                           [ariaExpanded]="isViewTouchpointDetailsPanelOpen"
                           [ariaLabel]="'View Details for ' + touchpoint.accountNumber"
                           (clickEvent)="clickViewTouchpointDetails($event, touchpoint)"></app-euds-button>
          <br />
          <app-euds-button type="tertiary"
                           size="small"
                           label="Summary"
                           [ariaLabel]="'Go to Summary for ' + touchpoint.accountNumber"
                           (clickEvent)="clickViewGoToSummaryDetails($event, touchpoint)"></app-euds-button>
        </td>
      </tr>
    </ng-container>
  </app-euds-data-table>
  <p *ngIf="displayedTouchpointsData?.length === 0" class="margin-top-4">No records found.</p>
  <app-euds-pagination #paginationTouchpoints
                       *ngIf="displayedTouchpointsData?.length > 0"
                       [itemsPerPageOptions]="itemsPerPageOptions"
                       [itemsPerPage]="itemsPerPage"
                       [totalItems]="totalTouchpoints"
                       (changeItemsPerPage)="onChangeItemsPerPage($event);"
                       (changePage)="onChangePage($event);">
  </app-euds-pagination>
  <app-drawer #drawer
              id="touchpoint-drawer"
              [heading]="drawerHeading"
              (onOpen)="onOpenDrawer($event)"
              (onClose)="onCloseDrawer($event)">
    <!-- Share button -->
    <div drawer-actions>
      <app-share *ngIf="isViewTouchpointDetailsPanelOpen && selectedTouchpoint" [data]="selectedTouchpoint"></app-share>
    </div>
    <ng-container *ngIf="isAddTouchpointPanelOpen">
      <app-touchpoint-form [opCoSelected]="opCoSelected" [opcoFieldError]="opcoFieldError" (formSubmitted)="onFormSubmitted($event)" *ngIf="!isAddTouchpointSuccessful"></app-touchpoint-form>
      <ng-container *ngIf="createTouchpointAttempted && isAddTouchpointSuccessful">
        <app-euds-alert type="success"
                        class="margin-bottom-6"
                        primaryText="Touchpoint successfully added. Please close the panel to refresh the data table."></app-euds-alert>
        <app-euds-button type="primary"
                         label="Close"
                         (clickEvent)="closeTouchpointAdditionPanel()"></app-euds-button>
      </ng-container>
      <!-- form validation error -->
      <ng-container *ngIf="createTouchpointAttempted && !isTouchpointDataValid">
        <app-euds-alert type="error"
                        primaryText="Unable to add touchpoint. Please check the input fields for errors and try again."></app-euds-alert>
      </ng-container>
      <!-- api / mismatch error -->
      <ng-container *ngIf="createTouchpointAttempted && isTouchpointDataValid && !isAddTouchpointSuccessful">
        <app-euds-alert type="error"
                        [primaryText]="errorMessage">
        </app-euds-alert>
      </ng-container>
      <div class="button-bar" *ngIf="!isAddTouchpointSuccessful">
        <app-euds-button type="primary"
                         label="Add Touchpoint"
                         (clickEvent)="addTouchpoint()"></app-euds-button>
        <app-euds-button type="secondary"
                         label="Cancel"
                         (clickEvent)="cancelTouchpointAddition()"></app-euds-button>
      </div>
    </ng-container>
    <ng-container *ngIf="isViewTouchpointDetailsPanelOpen">
      <pre class="touchpoint-details">{{selectedTouchpointOutput}}</pre>
      <div class="button-bar margin-top-4">
        <app-euds-button type="secondary"
                         label="Previous"
                         icon="feather/chevron-left"
                         iconPosition="left"
                         [disabled]="!canGoToPrevious()"
                         (clickEvent)="goToPreviousTouchpoint()"></app-euds-button>
        <app-euds-button type="secondary"
                         label="Next"
                         icon="feather/chevron-right"
                         iconPosition="right"
                         [disabled]="!canGoToNext()"
                         (clickEvent)="goToNextTouchpoint()"></app-euds-button>
      </div>
    </ng-container>
  </app-drawer>

  <app-euds-loader [visible]="isLoading"></app-euds-loader>
</ng-container>
